module.exports = __webpack_public_path__ + "media/images/lb/850-316f4eb2c5dfc2205389daed3b62373e.svg";